import { useMutation } from "react-query";
import downloadNoteSales from "../services/downloadNoteSales";

function useDownloadNoteSales() {
  return useMutation(["download-sales"], downloadNoteSales);
}

export default useDownloadNoteSales;
